import type {ReactElement} from 'react'
import * as React from 'react'
import type {EntryPointProps} from 'react-relay'
import {usePreloadedQuery} from 'react-relay'

import {DetailedInvestigationsViewContext} from '../../../../contexts/detailedView'
import type {ProjectId} from '../../../../types'

import type {ProjectInvestigationsTabCountQuery} from './__generated__/ProjectInvestigationsTabCountQuery.graphql'
import {countQuery} from './ProjectInvestigationsTab.queries'
import ProjectInvestigationsTabTestsTree from './ProjectInvestigationsTree/ProjectInvestigationsTabTestsTree'

type Props = {
  projectId: ProjectId
}

type Queries = {count: ProjectInvestigationsTabCountQuery}

function ProjectInvestigationsTab({
  queries,
  props,
}: EntryPointProps<Queries, {}, Props, {}>): ReactElement {
  const {testOccurrences} = usePreloadedQuery(countQuery, queries.count)
  const {projectId} = props
  const renderContent = React.useMemo(
    () => <ProjectInvestigationsTabTestsTree projectId={projectId} countKey={testOccurrences} />,
    [projectId, testOccurrences],
  )
  return (
    <DetailedInvestigationsViewContext.Provider value>
      <div>{renderContent}</div>
    </DetailedInvestigationsViewContext.Provider>
  )
}

export default React.memo(ProjectInvestigationsTab)
export type ProjectInvestigationsTabComponent = typeof ProjectInvestigationsTab
